(() => {
  if (window.__MF_PRIVATE_CART_PROPERTIES__) return;
  window.__MF_PRIVATE_CART_PROPERTIES__ = true;

  const previousFetch = window.fetch.bind(window);

  window.fetch = async function mfPrivateCartProperties(input, init = {}) {
    try {
      const url = typeof input === 'string' ? input : String(input?.url || '');
      const method = String(init?.method || 'GET').toUpperCase();
      const body = init?.body;

      if (
        method === 'POST' &&
        /\/cart\/add\.js(?:\?|$)/.test(url) &&
        body instanceof FormData &&
        String(body.get('properties[Personalisierung]') || '').includes('Tassen-Designer')
      ) {
        const customerPhoto = body.get('properties[Kundenfoto]');

        if (customerPhoto != null && !body.has('properties[_MF Kundenfoto]')) {
          body.delete('properties[Kundenfoto]');

          if (customerPhoto instanceof File) {
            body.append('properties[_MF Kundenfoto]', customerPhoto, customerPhoto.name || 'Kundenfoto.png');
          } else {
            body.append('properties[_MF Kundenfoto]', customerPhoto);
          }
        }
      }
    } catch (error) {
      console.warn('[MF Designer] Interne Warenkorb-Eigenschaften konnten nicht ergänzt werden', error);
    }

    return previousFetch(input, init);
  };
})();

(() => {
  if (window.__MF_TASSEN_PREVIEW_GEOMETRY_FIX_V1__) return;
  window.__MF_TASSEN_PREVIEW_GEOMETRY_FIX_V1__ = true;

  const originalText = window.Response?.prototype?.text;
  if (typeof originalText !== 'function') return;

  const oldGeometry = `const bodyHeight = Math.min(cssHeight * .76, 306);
            const bodyWidth = Math.min(bodyHeight * BODY_WIDTH_TO_HEIGHT, cssWidth * .48);`;

  const fixedGeometry = `const bodyHeight = Math.min(cssHeight * .76, 306, (cssWidth * .48) / BODY_WIDTH_TO_HEIGHT);
            const bodyWidth = bodyHeight * BODY_WIDTH_TO_HEIGHT;`;

  window.Response.prototype.text = async function mfDesignerResponseText(...args) {
    const text = await originalText.apply(this, args);

    if (
      typeof text === 'string' &&
      text.includes('function Mug3DPreview') &&
      text.includes(oldGeometry)
    ) {
      return text.replace(oldGeometry, fixedGeometry);
    }

    return text;
  };
})();
